import React from "react";
import useNickname from "../../../../hooks/site/useNickname";
import { useTranslation } from "react-i18next";
import { MODE_BY_TEXT } from "../../../common/enums";

export const ENUM_TYPE_JOIN = {
  join: "join",
  leave: "leave",
};

export default function MesJoin({ message }) {
  const { t } = useTranslation();
  const { nickname } = useNickname();
  const typeJoin = message.typeJoin;
  const joinText = typeJoin === ENUM_TYPE_JOIN.join ? "joined" : "came out of";

  return (
    <div className={"chat__free__message__change"}>
      <span className="chat__free__message__change__text">
        <span className="nick">{nickname}</span>
        <span>{t(joinText)}</span>
        <span className="mode">{MODE_BY_TEXT[message.mode]}</span>
      </span>
    </div>
  );
}
